import React from "react"
import { Box } from "@mui/system"
import { Icon, Typography } from "@mui/material"
import {
    OrevePopup,
    OrevePopupContent,
    OrevePopupTitle,
} from "components/popup/OrevePopup.tsx"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
interface UnauthorizedAccessPopupProps {
    open: boolean
    onClose:
        | (() => void)
        | ((
              event: React.SyntheticEvent,
              reason: "backdropClick" | "escapeKeyDown"
          ) => void)
    iconTitle: boolean
    popinTitle: string
    children: React.ReactNode
}

export const UnauthorizedAccessPopup = ({
    open,
    popinTitle,
    children,
}: UnauthorizedAccessPopupProps) => {
    return (
        <Box sx={{ bgcolor: "grey.100", height: "110vh", width: "100vw" }}>
            <OrevePopup open={open}>
                <OrevePopupTitle>
                    <Icon
                        sx={{
                            color: "error.main",
                            width: "37px",
                            height: "37px",
                        }}
                        component={ErrorOutlineIcon}
                    />
                    <Typography variant="headlineSmall">
                        {popinTitle}
                    </Typography>
                </OrevePopupTitle>
                <OrevePopupContent>{children}</OrevePopupContent>
            </OrevePopup>
        </Box>
    )
}
